import { render, staticRenderFns } from "./TransactionLimit.vue?vue&type=template&id=25f69bb8"
import script from "./TransactionLimit.vue?vue&type=script&lang=js"
export * from "./TransactionLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports